import { z } from 'zod';
import { inputsLength, otpRegex } from '@/domains/auth/constants/validation';

export const validationSchema = z.object({
  otp: z.string().regex(otpRegex).length(inputsLength.otp.min),
});
